import React, {
  useEffect,
  useState,
  useLayoutEffect,
  useRef,
  useCallback,
} from 'react';
import {
  View,
  Platform,
  KeyboardAvoidingView,
  StyleSheet,
  Text,
  Pressable,
  ActivityIndicator,
  TextInput,
  ScrollView,
} from 'react-native';

import {
  useFocusEffect,
  useNavigation,
  useRoute,
} from '@react-navigation/native';
import {NavigationKey} from '../../navigations/config';

import {RNEButton, RNEText} from '../../components';
import {colorPalette, colors} from '../../../core/config/color.config';
import {makeStyles, Overlay} from 'react-native-elements'; // rne-netzon replaced
import {
  useCancelConsultationDetail,
  useDeclineConsultationDetail,
} from '../../server/react-query/useConsultation';

import useStores from '../../stores/useStores';
import {width, height, totalSize} from 'react-native-dimension';
import ConsultationCancelConfirmationModal from '../../views/modal/ConsultationCancelConfirmationModal';

import {
  ConsultationAcceptDecline,
  ConsultationCancel,
  ConsultationChat,
  ConsultationDetailEntry,
  ConsultationDetailPlaceholder,
  ConsultationDoctorPopover,
  ConsultationDoctorProfileModal,
  ConsultationEndModal,
  ConsultationPatientMedicalModal,
  ConsultationPatientPopover,
  ConsultationStatus,
  ConsultationHistoryFooterNote,
  ContentScrollView,
  HeaderConsultationDoctor,
  HeaderConsultationDoctorWeb,
  HeaderConsultationPatient,
  HeaderConsultationPatientWeb,
  MedicalAttachmentsListView,
  ConsultationProceedToPayment,
} from '../../views';

import {
  useGetConsultationDetail,
  useMarkAsReadConsultation,
} from '../../server/react-query/useConsultation';
import {ConsultationStatusEnum} from '../../server/types/consultation.types';

import useConversation from '../../hooks/conversation/useConversation';

import {PopoverItemKey} from '../../views/popover/data/popoverItems.data';
import MedicalAttachmentsModal from '../../views/modal/MedicalAttachmentsModal';
import {MedicalAttachmentEnum} from '../../views/medical-attachments/data/medicalAttachment';
import {computeAge} from '../../utils/date.utils';
import {useGetAllMedicalAttachments} from '../../server/react-query/useMedicalAttachment';
import EmptyMedicalAttachmentsModal from '../../views/modal/EmptyMedicalAttachmentsModal';
import {ProcedureStatusEnum} from '../../server/types/procedure.types';
import useVideoCall from '../../hooks/video-call/useVideoCall';
import {REACT_APP_BASE_WEB_URL} from '../../server/api/api.config';
import {Dropdown} from 'react-native-element-dropdown';
import {useGetAdminConversationDoctors} from '../../server/react-query/useAdminChat';
import {usePullDownRefreshContext} from '../../stores/pullDownRefreshStore';

const ConsultationDeclineScreen = () => {
  const route = useRoute();
  const navigation = useNavigation();
  const {authStore, patientProfileStore, doctorProfileStore} = useStores();
  const {closeRoom, resetValues} = useVideoCall();

  const [recommendations, setRecommendations] = useState([
    {
      title: 'Refer to specialist',
      value: 'refer_to_specialist',
    },
    {
      title: 'Other recommendation',
      value: 'other',
    },
  ]);

  const [selectedRecommendation, setSelectedRecommendation] = useState(null);

  const {data: allDoctors, isLoading: isDoctorDataLoading} =
    useGetAdminConversationDoctors();

  const [doctors, setDoctors] = useState([]);

  const [selectedDoctor, setSelectedDoctor] = useState(null);

  const [otherRecommendationTxt, setOtherRecommendationTxt] = useState('');

  const [isSendRecommendationLoading, setIsSendRecommendationLoading] =
    useState(false);

  useEffect(() => {
    if (allDoctors && Array.isArray(allDoctors)) {
      const formattedDoctors = allDoctors
        .filter(
          item =>
            item.practitioner?.user?.userId !==
            authStore.authData?.user?.userId,
        ) // exclude self
        .map(item => {
          const p = item.practitioner;
          const doctorName = p.middleName?.trim()
            ? `${p.firstName} ${p.middleName} ${p.lastName}`
            : `${p.firstName} ${p.lastName}`;

          return {
            doctorName, // label
            value: p.practitionerId, // value
            specialization:
              p.practitionerRole?.[0]?.specialization?.value || '',
            hospital: p.organization?.[0]?.hospital?.value || '',
            photo: p.photo?.url || '',
          };
        });

      setDoctors(formattedDoctors);
    }
  }, [allDoctors, authStore.authData?.user?.userId]);

  useEffect(() => {
    setSelectedDoctor(null);
    setOtherRecommendationTxt('');
  }, [selectedRecommendation]);

  const {initialized, conversation, resetConversation} = useConversation();

  const [showIncorrectProfileDialog, setShowIncorrectProfileDialog] =
    useState(false);

  const [consultationId, setConsultationId] = useState();
  const [showEndConsultationDialog, setShowEndConsultationDialog] =
    useState(false);
  const [showMedicalAttachmentsDialog, setShowMedicalAttachmentsDialog] =
    useState(false);
  const [
    showEmptyMedicalAttachmentsDialog,
    setShowEmptyMedicalAttachmentsDialog,
  ] = useState(false);
  const [showMedicalAttachmentsScreen, setShowMedicalAttachmentsScreen] =
    useState(false);
  const [showViewDoctorProfileDialog, setShowViewDoctorProfileDialog] =
    useState(false);
  const [showHistoryDialog, setShowHistoryDialog] = useState(false);
  const [statusByPatient, setStatusByPatient] = useState(false);
  const [isArchiveConfirmModalVisible, setIsArchiveConfirmModalVisible] =
    useState(false);
  const [isBtnLoading, setIsBtnLoading] = useState(false);

  const {data: serviceRequest, isLoading} = useGetConsultationDetail({
    serviceRequestId: consultationId || '',
  });

  const {mutate: markAsReadMutate} = useMarkAsReadConsultation();

  const {data: medicalAttachments, refetch} = useGetAllMedicalAttachments({
    serviceRequestId: consultationId,
  });

  const declineMutation = useDeclineConsultationDetail({
    serviceRequestId: serviceRequest?.serviceRequestId,
    status: ConsultationStatusEnum.DECLINED,
  });

  const navProps = {
    procedureId: serviceRequest?.procedure?.procedureId,
    subjectId: serviceRequest?.subject.patientId,
    receiver:
      authStore.authData?.user.userRole === 'patient'
        ? serviceRequest?.procedure?.subject
        : serviceRequest?.procedure?.performer,
    serviceRequestId: serviceRequest?.serviceRequestId,
  };

  const notificationProps = {
    title:
      authStore.authData?.user.userRole === 'patient'
        ? 'New chat message for the doctor'
        : 'New chat message for the patient',
    body: 'Your consultation chat has a new message1.',
    consultation: `"${JSON.stringify(navProps)}"`,
    notificationUrl: `${REACT_APP_BASE_WEB_URL}main/consultation/detail?id=${consultationId}&screen=pending&tab=0`,
    fromUserId: authStore.authData?.user.userId!,
    toUserId:
      authStore.authData?.user.userRole === 'patient'
        ? serviceRequest?.performer.userId!
        : serviceRequest?.requester!,
  };

  const onMenuItemClick = async (itemKey: PopoverItemKey) => {
    let defaultAttachValues;
    if (
      serviceRequest &&
      serviceRequest.subject &&
      (serviceRequest.status === ConsultationStatusEnum.COMPLETED ||
        serviceRequest.status === ConsultationStatusEnum.ONGOING)
    ) {
      // console.log('serviceRequest', JSON.stringify(serviceRequest), 'serviceRequest');
      defaultAttachValues = {
        basedOnId: serviceRequest?.serviceRequestId,
        subject: serviceRequest?.subject.patientId,
        patientName: `${serviceRequest?.subject.humanName.given[0]} ${serviceRequest?.subject.humanName.family}`,
        age:
          serviceRequest?.subject.birthdate &&
          computeAge(serviceRequest?.subject.birthdate),
        userId: serviceRequest.subject.userId,
      };
    }

    switch (itemKey) {
      case PopoverItemKey.END_CONSULTATION:
        handleEndConsultation();
        break;

      case PopoverItemKey.MEDICAL_ATTACHMENTS:
        const res = await refetch();
        if (res.data && res.data?.length > 0) {
          if (Platform.OS === 'web') {
            setShowMedicalAttachmentsDialog(true);
          } else {
            setShowMedicalAttachmentsScreen(true);
          }
        } else {
          setShowEmptyMedicalAttachmentsDialog(true);
        }
        break;

      case PopoverItemKey.DOCTOR_PROFILE:
        handleViewDoctorProfile();
        break;

      case PopoverItemKey.MEDICAL_HISTORY:
        handleViewHistory();
        break;

      case PopoverItemKey.LABORATORY_REQUEST:
        navigation.navigate(NavigationKey.DOCTOR_ADD_MEDICAL_ATTACHMENT, {
          view: MedicalAttachmentEnum.LABORATORY_REQUEST,
          ...defaultAttachValues,
        });
        break;

      case PopoverItemKey.MEDICAL_CERTIFICATE:
        navigation.navigate(NavigationKey.DOCTOR_ADD_MEDICAL_ATTACHMENT, {
          view: MedicalAttachmentEnum.MEDICAL_CERTIFICATE,
          ...defaultAttachValues,
        });
        break;

      case PopoverItemKey.PRESCRIPTION:
        navigation.navigate(NavigationKey.DOCTOR_ADD_MEDICAL_ATTACHMENT, {
          view: MedicalAttachmentEnum.PRESCRIPTION,
          ...defaultAttachValues,
        });
        break;

      default:
        break;
    }
  };

  const handleEndConsultation = () => {
    setShowEndConsultationDialog(true);
  };

  const endConsultationCancel = () => {
    setShowEndConsultationDialog(false);
  };

  const endConsultationComplete = () => {
    setShowEndConsultationDialog(false);
    navigation.navigate(NavigationKey.DOCTOR_CONSULTATION_STACK, {
      screen: NavigationKey.CONSULTATION_LIST,
      params: {
        tab: 2,
        id: serviceRequest?.serviceRequestId,
      },
    });
  };

  const handleViewDoctorProfile = () => {
    if (Platform.OS === 'web') {
      setShowViewDoctorProfileDialog(true);
    } else {
      setShowMedicalAttachmentsScreen(false);
      if (serviceRequest) {
        navigation.navigate(NavigationKey.CONSULTATION_DOCTOR_PROFILE, {
          practitioner: serviceRequest?.performer,
        });
      }
    }
  };

  const handleViewHistory = () => {
    if (Platform.OS === 'web') {
      setShowHistoryDialog(true);
    } else {
      if (serviceRequest) {
        navigation.navigate(
          NavigationKey.CONSULTATION_PATIENT_MEDICAL_HISTORY,
          {
            patient: serviceRequest.subject,
            status: serviceRequest.status,
          },
        );
      }
    }
  };

  const sendMessage = (message: string) => {
    setShowMedicalAttachmentsScreen(false);

    // console.log('Initialized:', initialized);
    // console.log('Conversation:', conversation);

    if (initialized && conversation) {
      conversation.sendMessage(message);
    }
  };

  const navigateBackToTab = (consultationStatus?: ConsultationStatusEnum) => {
    let screen: NavigationKey;

    switch (consultationStatus) {
      case ConsultationStatusEnum.PENDING:
        screen = NavigationKey.CONSULTATION_TAB_PENDING;
        break;

      case ConsultationStatusEnum.ONGOING:
        screen = NavigationKey.CONSULTATION_TAB_ONGOING;
        break;

      case ConsultationStatusEnum.CANCELLED:
      case ConsultationStatusEnum.COMPLETED:
      case ConsultationStatusEnum.DECLINED:
        screen = NavigationKey.CONSULTATION_TAB_HISTORY;
        break;

      default:
        screen = NavigationKey.CONSULTATION_TAB_ONGOING;
        break;
    }

    if (screen) {
      navigation.navigate(NavigationKey.DOCTOR_CONSULTATION_STACK, {
        screen: NavigationKey.CONSULTATION_LIST,
        params: {
          screen: screen,
        },
      });
    }
  };

  const endCall = async (subjectId: string, roomId: string) => {
    await closeRoom(subjectId, roomId);
    resetValues();
  };

  useEffect(() => {
    const params: any = route.params;
    const patientId = patientProfileStore.activeProfile?.patientId;
    const doctor = doctorProfileStore.doctorStatus;

    if (
      params.subjectId !== undefined &&
      params.subjectId !== patientId &&
      !doctor
    ) {
      setShowIncorrectProfileDialog(true);
    }
    if (params || params?.params) {
      setConsultationId(params.id || params?.params?.id);

      if (params.declining) {
        endCall(params.subjectId, params.roomId);
      }

      // if (params.id !== consultationId) {
      //   resetConversation();
      // }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [route.params]);

  useEffect(() => {
    switch (authStore.userRole) {
      case 'practitioner':
        setStatusByPatient(
          !(authStore.auth?.user.userId === serviceRequest?.modifiedBy),
        );
        break;

      default:
        break;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authStore.userRole, serviceRequest]);

  useEffect(() => {
    const stack =
      authStore.userRole === 'patient'
        ? NavigationKey.PATIENT_CONSULTATION_STACK
        : NavigationKey.DOCTOR_CONSULTATION_STACK;
    const screen = NavigationKey.CONSULTATION_DECLINE;
    const id = serviceRequest?.serviceRequestId;
    let params = {};

    if (id) {
      switch (serviceRequest?.status) {
        case ConsultationStatusEnum.ONGOING:
          params = {
            tab: 0,
            screen: NavigationKey.CONSULTATION_TAB_PENDING,
            id: id,
          };
          break;

        case ConsultationStatusEnum.PENDING:
          params = {
            tab: 1,
            screen: NavigationKey.CONSULTATION_TAB_ONGOING,
            id: id,
          };
          break;

        case ConsultationStatusEnum.COMPLETED:
        case ConsultationStatusEnum.DECLINED:
        case ConsultationStatusEnum.CANCELLED:
        case ConsultationStatusEnum.ARCHIVED:
          params = {
            tab: 2,
            screen: NavigationKey.CONSULTATION_TAB_HISTORY,
            id: id,
          };
          break;
      }

      // navigation.navigate(stack, {
      //   screen: screen,
      //   params: params,
      // });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serviceRequest?.status]);

  useLayoutEffect(() => {
    if (Platform.OS !== 'web') {
      navigation.setOptions({
        title: '',
        headerLeft: () => {
          if (authStore.userRole === 'patient') {
            return (
              <HeaderConsultationDoctor
                serviceRequest={serviceRequest}
                onBackClickFromList={() => {
                  showMedicalAttachmentsScreen
                    ? setShowMedicalAttachmentsScreen(false)
                    : navigateBackToTab(serviceRequest?.status);
                }}
              />
            );
          } else if (authStore.userRole === 'practitioner') {
            return (
              <HeaderConsultationPatient
                serviceRequest={serviceRequest}
                onBackClickFromList={() => {
                  showMedicalAttachmentsScreen
                    ? setShowMedicalAttachmentsScreen(false)
                    : navigateBackToTab(serviceRequest?.status);
                }}
              />
            );
          } else {
            null;
          }
        },
        headerRight: () => (
          <View
            style={[
              styles.headerRight,
              {
                right:
                  serviceRequest?.status === ConsultationStatusEnum.PENDING
                    ? -width(0.5)
                    : width(2.5),
              },
            ]}>
            {!(
              serviceRequest?.status === ConsultationStatusEnum.ONGOING ||
              serviceRequest?.status === ConsultationStatusEnum.COMPLETED
            ) && (
              <ConsultationStatus
                consultationStatus={serviceRequest?.status}
                procedureStatus={serviceRequest?.procedure?.status}
                isActionByPatient={statusByPatient}
              />
            )}

            {(serviceRequest?.status === ConsultationStatusEnum.ONGOING ||
              serviceRequest?.status === ConsultationStatusEnum.COMPLETED) &&
              authStore.userRole === 'patient' &&
              !!serviceRequest && (
                <>
                  {serviceRequest?.status ===
                    ConsultationStatusEnum.ONGOING && (
                    <View style={{marginRight: width(2)}}>
                      <Text
                        style={{
                          color: colors.mediumTurquoise.regular,
                          fontSize: totalSize(1.6),
                          fontFamily: 'Quicksand-Bold',
                        }}>
                        On Going
                      </Text>
                    </View>
                  )}
                  <ConsultationPatientPopover
                    status={serviceRequest.status}
                    onMenuItemClick={onMenuItemClick}
                  />
                </>
              )}

            {(serviceRequest?.status === ConsultationStatusEnum.ONGOING ||
              serviceRequest?.status === ConsultationStatusEnum.COMPLETED) &&
              authStore.userRole === 'practitioner' && (
                <ConsultationDoctorPopover
                  status={serviceRequest.status}
                  onMenuItemClick={onMenuItemClick}
                />
              )}
          </View>
        ),
        headerStyle: {
          borderBottomColor: colorPalette.light,
          borderBottomWidth: width(0.2),
          elevation: 0,
          shadowOpacity: 0,
        },
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    navigation,
    serviceRequest,
    authStore.userRole,
    statusByPatient,
    showMedicalAttachmentsScreen,
  ]);

  const getSendButtonBgColor = () => {
    if (selectedRecommendation) {
      if (selectedRecommendation.value === 'other') {
        if (otherRecommendationTxt.trim()) {
          return colorPalette.secondary;
        } else {
          return colorPalette.grey;
        }
      } else {
        if (selectedDoctor && Object.keys(selectedDoctor).length > 0) {
          return colorPalette.secondary;
        } else {
          return colorPalette.grey;
        }
      }
    } else {
      return colorPalette.grey;
    }
  };

  const sendRecommendationRequest = () => {
    setIsSendRecommendationLoading(true);

    declineMutation.mutate(
      {
        serviceRequestId: serviceRequest?.serviceRequestId,
        status: ConsultationStatusEnum.DECLINED,
        recommendationType: selectedRecommendation.value,
        recommendationValue:
          selectedRecommendation.value === 'other'
            ? otherRecommendationTxt
            : selectedDoctor.value,
      },
      {
        onSuccess: () => {
          setSelectedRecommendation(null);
          setOtherRecommendationTxt('');
          setSelectedDoctor(null);

          setIsSendRecommendationLoading(false);

          navigation.goBack(-1);
        },
        onError: () => {
          setIsSendRecommendationLoading(false);
        },
      },
    );
  };

  const {setCanRefresh} = usePullDownRefreshContext();

  const [scrollViewHeight, setScrollViewHeight] = useState(0);
  const [contentHeight, setContentHeight] = useState(0);
  const [scrollY, setScrollY] = useState(0);

  useFocusEffect(
    useCallback(() => {
      if (scrollViewHeight > 0 && contentHeight > 0) {
        const isScrollable = contentHeight > scrollViewHeight;

        if (!isScrollable) {
          setCanRefresh(true); // always allow pull-down if not scrollable
        } else {
          setCanRefresh(scrollY <= 0); // only allow when scrolled to top
        }
      }
    }, [scrollViewHeight, contentHeight, scrollY, setCanRefresh]),
  );
  const handleScroll = (e: any) => {
    const y = e.nativeEvent.contentOffset.y;
    setScrollY(y);

    const isScrollable = contentHeight > scrollViewHeight;

    if (!isScrollable) {
      setCanRefresh(true); // still always true if no scroll
    } else {
      setCanRefresh(y <= 0); // only true when back at the very top
    }
  };

  return (
    <>
      <KeyboardAvoidingView
        style={{flex: 1}}
        behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
        keyboardVerticalOffset={Platform.OS === 'ios' ? 80 : 0}>
        <ScrollView
          onScroll={handleScroll}
          onLayout={e => {
            setScrollViewHeight(e.nativeEvent.layout.height);
          }}
          onContentSizeChange={(contentWidth, contentHeight) => {
            setContentHeight(contentHeight);
          }}
          contentContainerStyle={{flexGrow: 1}}
          keyboardShouldPersistTaps="handled">
          <View style={styles.root}>
            <View
              style={{
                flex: 1,
                padding: totalSize(3.5),
                paddingTop: totalSize(2),
              }}>
              <View
                style={{
                  flexDirection: 'column',
                  gap: totalSize(2),
                  marginBottom: height(2),
                }}>
                <Text
                  style={{
                    textAlign: 'center',
                    fontSize: totalSize(1.7),
                    color: colors.midnightBlue.dark,
                    fontFamily: 'Quicksand-Bold',
                  }}>
                  Consultation Request Declined
                </Text>

                <Text
                  style={{
                    fontFamily: 'Quicksand-Medium',
                    fontSize: totalSize(1.5),
                  }}>
                  The patient needs to understand why you are declining this
                  request and the steps that the patient needs to take next.
                </Text>

                <Text>{"Let's help the patient out."}</Text>
              </View>

              <View style={{marginBottom: height(2)}}>
                <Text
                  style={{
                    fontFamily: 'Quicksand-SemiBold',
                    color: colorPalette.black,
                    marginBottom: height(0.5),
                  }}>
                  Recommendation:
                </Text>
                <Dropdown
                  data={recommendations}
                  placeholderStyle={{color: colors.gray.regular}}
                  style={{
                    borderWidth: width(0.3),
                    borderColor: colors.midnightBlue.dark,
                    borderRadius: totalSize(1),
                    padding: totalSize(1),
                  }}
                  mode={'default'}
                  maxHeight={300}
                  labelField="title"
                  valueField="value"
                  placeholder={'Select'}
                  value={selectedRecommendation}
                  onChange={item => {
                    setSelectedRecommendation(item);
                  }}
                />
              </View>

              <View>
                {selectedRecommendation &&
                  selectedRecommendation?.value === 'refer_to_specialist' && (
                    <View>
                      <Text
                        style={{
                          fontFamily: 'Quicksand-SemiBold',
                          color: colorPalette.black,
                          marginBottom: height(0.5),
                        }}>
                        Specialist:
                      </Text>
                      <View
                        style={{
                          flexDirection: !isDoctorDataLoading
                            ? 'column'
                            : 'row',
                          gap: width(5),
                        }}>
                        <Dropdown
                          data={doctors}
                          // placeholderStyle={{color: theme.colors?.grey0}}
                          style={[
                            {
                              borderWidth: width(0.3),
                              borderColor: colors.midnightBlue.dark,
                              borderRadius: totalSize(1),
                              padding: totalSize(1),
                            },
                            isDoctorDataLoading && {width: width(70)},
                          ]}
                          mode={'default'}
                          maxHeight={300}
                          labelField="doctorName"
                          valueField="value"
                          placeholder={'Select'}
                          value={setSelectedDoctor}
                          onChange={item => {
                            setSelectedDoctor(item);
                          }}
                        />
                        {isDoctorDataLoading && (
                          <ActivityIndicator
                            size="large"
                            color={colorPalette.primary}
                          />
                        )}
                      </View>
                    </View>
                  )}

                {selectedRecommendation &&
                  selectedRecommendation?.value === 'other' && (
                    <View>
                      <Text
                        style={{
                          fontFamily: 'Quicksand-SemiBold',
                          color: colorPalette.black,
                          marginBottom: height(0.5),
                        }}>
                        Other Recommendation:
                      </Text>
                      <TextInput
                        style={styles.textarea}
                        placeholder="Please enter other recommendation here"
                        value={otherRecommendationTxt}
                        onChangeText={txt => {
                          setOtherRecommendationTxt(txt);
                        }}
                        multiline={true}
                        numberOfLines={5}
                        textAlignVertical="top"
                      />
                    </View>
                  )}
              </View>
            </View>

            <View style={styles.footer}>
              <Pressable
                onPress={sendRecommendationRequest}
                disabled={
                  isSendRecommendationLoading ||
                  !selectedRecommendation ||
                  (!selectedDoctor && !otherRecommendationTxt)
                }>
                <View
                  style={[
                    styles.button,
                    {backgroundColor: getSendButtonBgColor()},
                    isSendRecommendationLoading && {minWidth: width(60)},
                  ]}>
                  {isSendRecommendationLoading ? (
                    <ActivityIndicator
                      size={totalSize(3)}
                      color={colorPalette.white}
                    />
                  ) : (
                    <Text style={styles.buttonText}>Send Recommendation</Text>
                  )}
                </View>
              </Pressable>
            </View>
          </View>
        </ScrollView>
      </KeyboardAvoidingView>
    </>
  );
};

const styles = StyleSheet.create({
  root: {
    flex: 1,
  },
  textarea: {
    height: height(25),
    borderColor: colors.midnightBlue.dark,
    borderWidth: width(0.3),
    borderRadius: totalSize(1),
    padding: totalSize(1),
    fontSize: totalSize(1.6),
  },
  footer: {
    padding: totalSize(1.5),
    marginBottom: height(2),
    alignItems: 'center',
    justifyContent: 'center',
  },
  button: {
    backgroundColor: colorPalette.secondary,
    paddingVertical: totalSize(1.2),
    paddingHorizontal: totalSize(4),
    borderRadius: totalSize(5),
  },
  buttonText: {
    color: '#fff',
    fontFamily: 'Quicksand-Bold',
    fontSize: totalSize(1.6),
  },
  detailPlaceholder: {
    flex: 1,
    paddingBottom: 60,
  },
  content: {
    flexDirection: 'column',
    flex: 1,
    width: '100%',
  },
  messages: {
    flex: 1,
    width: '100%',
  },
  messagesWrapper: {
    alignItems: 'center',
  },
  headerRight: {
    flexDirection: 'row',
    // paddingHorizontal: 12,
    // paddingHorizontal: -15,
    // paddingRight: width(8),
    position: 'absolute',
    // right: width(5),
  },
  contentLimit: {
    width: '100%',
    paddingHorizontal: width(4),
  },
  contentLimitChat: {
    paddingHorizontal: 0,
  },
  overlayContainer: {
    borderRadius: 20,
    marginHorizontal: 40,
  },
  listContainer: {
    maxWidth: 860,
    width: '100%',
    flex: 1,
  },
  contentPlaceholder: {
    marginTop: 24,
  },
  boxHeaderDoctor: {
    height: 68,
    backgroundColor: colorPalette.success,
    width: '100%',
  },
  boxHeaderPatient: {
    height: 68,
    backgroundColor: colorPalette.primary,
    width: '100%',
  },
  container: {
    borderWidth: totalSize(0.2),
    padding: totalSize(1.5),
    paddingTop: totalSize(1),
    paddingBottom: totalSize(1),
    paddingRight: width(6.5),
    paddingLeft: width(6.5),
    borderRadius: totalSize(5),
    alignSelf: 'center',
  },
  archiveContainer: {
    borderColor: '#3FB4E6',
    backgroundColor: '#3FB4E6',
  },
  btnContainer: {
    minWidth: width(12),
    maxWidth: width(12),
  },
  btnTxtStyle: {
    textAlign: 'center',
    color: colorPalette.white,
    fontFamily: 'Quicksand-Bold',
    fontSize: totalSize(1.3),
  },
});

const rneStyles = StyleSheet.create({
  root: {
    maxWidth: Platform.OS === 'web' ? 420 : '80%',
    padding: Platform.OS === 'web' ? 32 : 16,
  },
  subtitleContainer: {
    marginTop: 20,
  },
  actionContainer: {
    marginTop: 36,
    alignItems: 'center',
  },
  buttonStyle: {
    width: 200,
  },
  overlayContainer: {
    borderRadius: 20,
    marginHorizontal: 40,
  },
  archivebutton: {
    backgroundColor: '#1E9CE4',
    borderRadius: 30, // pill shape
    paddingVertical: 12,
    paddingHorizontal: 50,
    shadowColor: '#000',
    shadowOpacity: 0.1,
    shadowOffset: {width: 0, height: 2},
    shadowRadius: 3,
    elevation: 3,
  },
  archivecontent: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  archivetext: {
    color: '#fff',
    fontSize: 14,
    fontWeight: '500',
    marginLeft: 6,
  },
  archiveButtonContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    position: 'absolute',
    bottom: totalSize(11),
    alignSelf: 'center',
    zIndex: 1000,
  },
});

export default ConsultationDeclineScreen;
